import { render } from "./DeleteExercisesModal.vue?vue&type=template&id=51f3af80&ts=true"
import script from "./DeleteExercisesModal.vue?vue&type=script&lang=ts"
export * from "./DeleteExercisesModal.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__